module.exports = __webpack_public_path__ + "static/media/7.f6dddb62.svg";